import growth from 'images/icon-growth.svg';
import heads from 'images/icon-heads.svg';
import orbit from 'images/icon-orbit.svg';
import particles from 'images/icon-particles.svg';
import speech from 'images/icon-speech.svg';
import stairs from 'images/icon-stairs.svg';
import star from 'images/icon-star.svg';
import sunset from 'images/icon-sunset.svg';
import waves from 'images/icon-waves.svg';

const iconURLs = {
  growth,
  heads,
  orbit,
  particles,
  speech,
  stairs,
  star,
  sunset,
  waves
};

export default iconURLs;